import { useMutation } from '@tanstack/react-query';

import { axios } from '@/src/lib/axios/axios';
import { generateRoutePath } from '@/src/routes';

import { QUICKBOOKS_BASE_URL } from '.';

import { Draft } from '../types/draft';
import { Treatment, TreatmentType } from '../types/treatment';

type SaveDraftParams = {
  documentId: number;
  params: {
    type?: TreatmentType;
    transaction: Treatment['payload'];
  };
};

type SaveTreatmentResponse = {
  draftId: Draft['draftId'];
};

const saveDraft = ({ documentId, params }: SaveDraftParams): Promise<SaveTreatmentResponse> => {
  const url = generateRoutePath(`${QUICKBOOKS_BASE_URL}/:documentId/drafts`, { documentId });

  return axios.post(url, params);
};

export const useSaveDraft = () => {
  return useMutation({
    mutationFn: (mutationsParams: SaveDraftParams) => saveDraft(mutationsParams),
  });
};
